
  (function () {
    if (window.__aysCroBundle) return;
    var FREE = 500000; /* Rs 5,000 in paisa */
    function money(p) { return 'Rs ' + Math.ceil(p / 100).toLocaleString('en-PK'); }
    function compute(cart, ids) {
      var tees = 0, teeOrig = 0, other = 0;
      cart.items.forEach(function (it) {
        if (ids.indexOf(String(it.product_id)) > -1) { tees += it.quantity; teeOrig += it.original_line_price; }
        else { other += it.final_line_price; }
      });
      var est = other + (tees >= 2 ? Math.round(teeOrig * 0.9) : teeOrig);
      var free = est >= FREE, gap = FREE - est, txt = '', done = false;
      if (tees === 0) {
        txt = free ? '✓ Free delivery unlocked · add 2 tees for an extra 10% off' : 'Buy any 2 tees → get an extra 10% off';
      } else if (tees === 1) {
        txt = 'Add 1 more tee → get an extra 10% off' + (free ? ' · ✓ free delivery unlocked' : '');
      } else if (free) {
        txt = '✓ Extra 10% off + free delivery unlocked'; done = true;
      } else if (tees === 2) {
        txt = '✓ Extra 10% off unlocked · add 1 more tee for free delivery';
      } else {
        txt = '✓ Extra 10% off unlocked · add ' + money(gap) + ' more for free delivery';
      }
      return { txt: txt, done: done };
    }

    var injecting = false;
    function injectDrawer() {
      var host = document.querySelector('#CartDrawer-CartItems');
      if (!host || injecting) return;
      var wrap = host.querySelector('.drawer__cart-items-wrapper');
      if (!wrap || host.querySelector('.ays-cro-bundle')) return;
      injecting = true;
      fetch(window.location.pathname + '?sections=ays-cro-bundle-fragment')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var tmp = document.createElement('div'); tmp.innerHTML = d['ays-cro-bundle-fragment'] || '';
          var el = tmp.querySelector('.ays-cro-bundle');
          var h = document.querySelector('#CartDrawer-CartItems');
          var w = h && h.querySelector('.drawer__cart-items-wrapper');
          if (el && w && !h.querySelector('.ays-cro-bundle')) { w.insertAdjacentElement('afterend', el); }
          injecting = false; refresh();
        })
        .catch(function () { injecting = false; });
    }

    var notifBusy = false;
    function injectNotif() {
      var n = document.querySelector('#cart-notification');
      if (!n || notifBusy) return;
      notifBusy = true;
      fetch(window.location.pathname + '?sections=ays-cro-bundle-fragment')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var tmp = document.createElement('div'); tmp.innerHTML = d['ays-cro-bundle-fragment'] || '';
          var el = tmp.querySelector('.ays-cro-bundle');
          var old = n.querySelector('.ays-cro-bundle'); if (old) old.remove();
          var anchor = n.querySelector('#cart-notification-product');
          if (el && anchor) { el.classList.add('ays-cro-bundle--notif'); anchor.insertAdjacentElement('afterend', el); }
          notifBusy = false; refresh();
        })
        .catch(function () { notifBusy = false; });
    }
    function refresh() {
      var boxes = document.querySelectorAll('.ays-cro-bundle');
      if (!boxes.length) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        boxes.forEach(function (box) {
          var msg = box.querySelector('.ays-cro-bundle__msg');
          if (!cart.item_count) { msg.textContent = ''; return; }
          var ids = (box.getAttribute('data-tee-ids') || '').split(',');
          var r = compute(cart, ids);
          msg.textContent = r.txt; msg.classList.toggle('is-done', r.done);
        });
      }).catch(function () {});
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.ays-cro-bundle__add');
      if (!btn) return;
      var card = btn.closest('.ays-cro-bundle__card'), box = btn.closest('.ays-cro-bundle');
      var id = card.querySelector('.ays-cro-bundle__sel').value;
      btn.disabled = true; btn.textContent = 'Adding…';
      var drawer = document.querySelector('cart-drawer'), notifEl = document.querySelector('cart-notification');
      var where = btn.closest('#CartDrawer') ? 'drawer' : (btn.closest('#cart-notification') ? 'notif' : 'page');
      var body = { items: [{ id: Number(id), quantity: 1 }] };
      if (where === 'drawer') { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      if (where === 'notif') { body.sections = 'cart-notification-product,cart-notification-button,cart-icon-bubble'; body.sections_url = window.location.pathname; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { btn.textContent = 'Sold out'; return; }
          if (where === 'page') { window.location.reload(); return; }
          var item = (res.items && res.items[0]) || {};
          item.sections = res.sections;
          if (where === 'drawer' && drawer && typeof drawer.renderContents === 'function') { drawer.renderContents(item); }
          if (where === 'notif' && notifEl && typeof notifEl.renderContents === 'function') { notifEl.renderContents(item); setTimeout(injectNotif, 60); }
          refresh();
        })
        .catch(function () { btn.disabled = false; btn.textContent = '+ Add'; });
    });
    function hook() { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') { subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) { setTimeout(function () { injectDrawer(); if (!ev || ev.source !== 'ays-cro-bundle') injectNotif(); refresh(); }, 80); }); } injectDrawer(); refresh(); }
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) { for (var j = 0; j < m[i].addedNodes.length; j++) { var n = m[i].addedNodes[j]; if (n.nodeType === 1 && (n.matches('.ays-cro-bundle') || n.querySelector('.ays-cro-bundle'))) { refresh(); return; } if (n.nodeType === 1 && (n.id === 'CartDrawer' || n.closest('#CartDrawer') || n.querySelector('#CartDrawer-CartItems'))) { setTimeout(injectDrawer, 30); return; } } }
    }).observe(document.documentElement, { childList: true, subtree: true });
    window.__aysCroBundle = { refresh: refresh };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hook); else hook();
  })();
